export default function SvgDash3() {
  return (
    <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      cursor="pointer"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#444"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M6 12h12"
      ></path>
    </svg>
   </>
  );
}
